<template>
    <sarala-table :model="model" :query="query" />
</template>

<script>
import CancellationRequisition from '@/models/CancellationRequisition'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    props: ['customer_id'],

    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new CancellationRequisition()
        },
    },

    methods: {
        query(model) {
            if (this.customer_id) {
                model.where('customer_id', this.customer_id)
            }
        },
    },
}
</script>

<style></style>
